<template>
    <form :action="`/account/${user.username}/questions`"
          method="POST"
          class="form questions-form"
          @submit.prevent="submit()">

        <template v-for="(question, index) in form.questions">
            <question-item @is-open="handleIsOpen"
                           :index="index"
                           :questions="availableQuestions"
                           :question="form.questions[index]">
            </question-item>
        </template>

        <span class="error" v-if="form.errors.has('unique')" v-text="form.errors.unique"></span>

        <div class="form__button">
            <button class="button form-submit on-vue" :class="{'disabled': form.isSubmitted, 'hidden' : !questionsOpened }" type="submit">
                <div v-if="form.isSubmitted">
                    Submitting
                </div>
                <div v-else>Save</div>
            </button>
        </div>

    </form>
</template>
<script>

import QuestionItem from "./QuestionItem";
import Form from '@/classes/Form'

export default {

    components:{
        QuestionItem
    },

    props: ['user', 'questions'],

    data() {
        return {
            currentUser: this.user,
            questionsOpened: 0,
            form: new Form({
                questions: this.user.questions,
            }).dontClear()
        }
    },

    methods: {

        submit() {
            this.form.put(`/account/${this.currentUser.username}/questions`)
                .then(response => {
                    this.currentUser = response.user
                    eventBus.$emit('form-submitted-success');
                    // this.form.questions = this.currentUser.questions
                })
        },

        handleIsOpen(event) {
            event ? this.questionsOpened++ : this.questionsOpened--
        }
    },

    computed:{
        availableQuestions(){
            return this.questions
        }
    }
}
</script>